module.exports = __webpack_public_path__ + "img/icon-tab-2.b1702f9f.svg";